<template>
  <footer class="footer">
    <!-- <div class="footer-left">
      <div>
        <span>{{ $t("address") }}</span>
        <span style="margin-left: 40px">{{ $t("phone") }}</span>
      </div>
      <div>{{ $t("copyright") }}</div>
    </div>
    <div class="footer-right">
      <div>{{ $t("links_title") }}</div>
      <a href="https://ele.pku.edu.cn/" target="_blank">{{ $t("school") }}</a>
      <span style="margin: 0 10px">|</span>
      <a href="http://www.geespace.com/" target="_blank">{{ $t("tech") }}</a>
    </div> -->
    <div class="footerp1"><img src="@/assets/images/footer1.png" alt="" /></div>
    <div class="footerp2">
      <div class="footerp2_lt">
        <div class="footerp2_p1">{{ $t("linkUs") }}</div>
        <div class="footerp2_p2">
          <img src="@/assets/images/address.png" alt="" />{{ $t("address") }}
        </div>
        <div class="footerp2_p3">
          <img src="@/assets/images/phone.png" alt="" />{{ $t("phone") }}
        </div>
      </div>
      <div class="footerp2_rt">
        <div class="footerp2_rt_p1">{{ $t("links_title") }}</div>
        <div class="footerp2_rt_p2">
          <a href="https://ele.pku.edu.cn/" target="_blank">{{
            $t("school")
          }}</a>
        </div>
        <div class="footerp2_rt_p3">
          <a href="http://www.geespace.com/" target="_blank">{{
            $t("tech")
          }}</a>
        </div>
      </div>
    </div>
    <div class="footerp3">
      <span>COPYRIGHT © 2025</span> 北京大学时空道宇先进通信联合实验室
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>
<style scoped lang="scss">
.footer {
  background: url("../assets/images/footer.png") no-repeat;
  height: 640px;
  padding: 10px;
  padding: 0 8vw;
  .footerp1 {
    width: 100%;
    margin-top: 133px;
    float: left;
    img {
      margin-left: 20px;
    }
  }
  .footerp2 {
    display: flex;
    margin-top: 124px;
    float: left;
    width: 100%;
    justify-content: space-between;
    .footerp2_lt {
      width: 30%;
      margin-left: 20px;
      .footerp2_p1 {
        font-size: 18px;
        font-weight: bold;
      }
      .footerp2_p2 {
        font-size: 15px;
        margin: 50px 0;
        color: #fefefe;
        display: flex;
        align-content: center;
        img {
          margin-right: 28px;
        }
      }
      .footerp2_p3 {
        font-size: 15px;
        margin: 50px 0;
        color: #fefefe;
        display: flex;
        align-content: center;
        img {
          margin-right: 28px;
        }
      }
    }
    .footerp2_rt {
      width: 25%;
      .footerp2_rt_p1 {
        font-size: 18px;
        font-weight: bold;
      }
      .footerp2_rt_p2 {
        font-size: 15px;
        margin: 50px 0;
        color: #fefefe;
        a {
          cursor: pointer;
        }
      }
      .footerp2_rt_p3 {
        font-size: 15px;
        color: #fefefe;
        a {
          cursor: pointer;
        }
      }
    }
  }

  .footerp3 {
    width: 100%;
    height: 69px;
    line-height: 69px;
    font-size: 15px;
    margin-top: 40px;
    text-align: center;
    border-top: solid 1px rgba(206, 206, 206, 0.4);
    float: left;
    span {
      font-weight: bold;
    }
  }
}
</style> 